<script setup lang="ts">
export type PanelProps = {
  id?: string
  componentName?: string
  supportingData?: {
    home: {
      variant?: {
        value: string
      }
      width?: {
        value: string
      }
      contentType?: {
        value: string
      }
    }
  }
  personalizationTags?: PersonalizationTags
  priority?: boolean
}

const { priority, ...props } = defineProps<PanelProps>()
const attrs = useAttrs()
if (priority) provide(MEDIA_PRIORITY_KEY, true)
const variant = computed(() => props.supportingData?.['home']?.variant?.value || 'unknown')
const width = props.supportingData?.['home']?.width?.value
const contentType = props.supportingData?.['home']?.contentType?.value

const currentComponent = computed(() => {
  switch (props.componentName) {
    case 'accordionPanel':
      return resolveComponent('AccordionPanel')
    case 'anchorLink':
      return resolveComponent('AnchorLink')
    case 'articlePanel':
      return resolveComponent('BlogArticlePanel')
    // case 'callToAction':
    //   return resolveComponent("Action");
    case 'cardPanel':
      return resolveComponent('CardPanelSwitcher')
    case 'columnPanel':
      return resolveComponent('ColumnPanel')
    case 'embedPanel':
      return resolveComponent('EmbedPanel')
    case 'heroPanel':
      return resolveComponent('HeroPanelSwitcher')
    case 'markdownPanel':
      return resolveComponent('MarkdownPanel')
    case 'productCarousel':
      return resolveComponent('ProductCarousel')
    case 'recommender':
      return resolveComponent('RecommendationRotator')
    case 'richTextPanel':
      return resolveComponent('RichTextPanel')
    // case 'sectionPanel':
    //   return resolveComponent("SectionPanelVariantSwitcher");
    case 'slimBanner':
      return resolveComponent('SlimBannerSwitcher')
    case 'table':
      return resolveComponent('Table')
    case 'utilityPanel':
      return resolveComponent('UtilityPanelGridLinks') /* If not PLP, UtilityPanel is only used for Grid Links style */
    case 'video' /* Video could be standalone Panel OR inline eg: inside ColumnPanel */:
      return attrs.url ? resolveComponent('MediaPanel') : resolveComponent('Media')
    case 'picture' /* Picture could be standalone Panel OR inline eg: inside ColumnPanel */:
      return attrs.picture ? resolveComponent('MediaPanel') : resolveComponent('Media')
    case 'brazeContentCardFeed':
      return resolveComponent('BrazeContentCardFeed')
    case 'brazeBanner':
      return resolveComponent('BrazeBanner')
    default:
      return resolveComponent('Undefined')
  }
})
</script>

<template>
  <!-- @vue-skip -->
  <component
    v-if="personalizationControl(personalizationTags)"
    :is="currentComponent"
    v-bind="{
      ...props,
      ...$attrs,
      variant,
      width,
      contentType,
    }"
  >
    <!-- Handle both slot function and non-function cases -->
    <slot v-if="$slots.default && typeof $slots.default === 'function'">
      {{ $slots.default() }}
    </slot>
  </component>
</template>

<style>
/* Vite CSS needs a style block */
</style>
